export const useHost = () => {
  return process.env.AUTH_PF_PHARMACIST_API_HOST!
}
